import { calculateRatio } from './helpers';
import RatioStatCard from './RatioStatCard';

const SingleRoomRatioStats = ({ roomData }) => {
	const ratio = calculateRatio(roomData);
	const requiredStaff = Math.ceil((roomData.ratios.student_count / ratio.students) * ratio.staff);
	const isOutOfRatio = roomData.ratios.staff_count < requiredStaff;

	return (
		<div className="flex gap-24 justify-between">
			<RatioStatCard title="Students Checked In" value={roomData.ratios.student_count} />
			<RatioStatCard title="Teachers Checked In" value={roomData.ratios.staff_count} />
			<RatioStatCard title="Live Room Ratio" value={isOutOfRatio ? `Out of ratio` : `In Ratio`} />
		</div>
	);
};

export default SingleRoomRatioStats;
